import { render, staticRenderFns } from "./before-page-chat-item.vue?vue&type=template&id=da85ba04&scoped=true&"
import script from "./before-page-chat-item.vue?vue&type=script&lang=js&"
export * from "./before-page-chat-item.vue?vue&type=script&lang=js&"
import style0 from "./before-page-chat-item.vue?vue&type=style&index=0&id=da85ba04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da85ba04",
  null
  
)

export default component.exports